"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var _b = _a.marginTop, marginTop = _b === void 0 ? '12px' : _b;
            return ({
                display: 'flex',
                flexDirection: 'column',
                marginTop: marginTop,
            });
        },
    });
});
